// extracted by mini-css-extract-plugin
export default {"tableContainer":"EconSingleSeriesUI_tableContainer__urEu4","table":"EconSingleSeriesUI_table__nt49c"};